/** Map path prefixes to dynamic import() for Vite-split page chunks. */
const PREFETCHERS: Array<{ match: (path: string) => boolean; load: () => Promise<unknown> }> = [
  { match: (p) => p === '/' || p === '', load: () => import('../pages/DashboardPage.tsx') },
  { match: (p) => p === '/servers' || p === '/servers/', load: () => import('../pages/ServersPage.tsx') },
  { match: (p) => p.startsWith('/servers/runtime'), load: () => import('../pages/RuntimeOverviewPage.tsx') },
  { match: (p) => p.startsWith('/servers/services'), load: () => import('../pages/ServicesPage.tsx') },
  { match: (p) => p.startsWith('/servers/sites'), load: () => import('../pages/SitesPage.tsx') },
  {
    match: (p) => p.startsWith('/servers/domain-certificates'),
    load: () => import('../pages/DomainCertificatesPage.tsx'),
  },
  {
    match: (p) => p.startsWith('/servers/timeline'),
    load: () => import('../pages/OpsTimelinePage.tsx'),
  },
];

const warmed = new Set<string>();

export function prefetchRoute(path: string): void {
  for (const entry of PREFETCHERS) {
    if (!entry.match(path)) continue;
    const key = entry.load.toString();
    if (warmed.has(key)) return;
    warmed.add(key);
    void entry.load().catch(() => {
      warmed.delete(key);
    });
    return;
  }
}

export function prefetchOpsBundle(): void {
  for (const path of [
    '/servers',
    '/servers/runtime',
    '/servers/services',
    '/servers/sites',
    '/servers/domain-certificates',
    '/servers/timeline',
  ]) {
    prefetchRoute(path);
  }
}

export function _resetPrefetchWarmupForTests(): void {
  warmed.clear();
}
